import type { RootState } from '../..';

const selectIsLoading = (state: RootState) => state.configurationsState.isLoading;

const selectConfigurations = (state: RootState) => state.configurationsState.configurations;

const selectHasError = (state: RootState) => state.configurationsState.hasError;

export const configurationsSelectors = {
  selectIsLoading,
  selectConfigurations,
  selectHasError,
};
